/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Copy_LabelInputs */



/**
* | output |
* | --- |
* | "Copy to clipboard" |
*
* @param {Options_Api_Keys_Copy_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_copy_label = /** @type {((inputs?: Options_Api_Keys_Copy_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Copy_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier dans le presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("In die Zwischenablage kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia negli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать в буфер обмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar al portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制到剪贴板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリップボードにコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लिपबोर्ड पर कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar para a área de transferência")
	return /** @type {LocalizedString} */ ("Copy to clipboard")
});